import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { appstore, googleplay } from "../../assets/img";
import { useDispatch, useSelector } from "react-redux";

export const SET_SETTINGS = "SET_SETTINGS";

export const setSettingsAll = (payload: any) => ({
  type: SET_SETTINGS,
  payload,
});

function FooterTwo() {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const Url = window.location.host;
  const blogUrl = `https://blog.${Url}`;
  const [areaCovered, setAreaCovered] = useState<any | null>({});
  const [settings, setSettings] = useState<any>({});
  const jsonData: any = useSelector<any>((state) => state?.homeJsonList);

  const base_url = process.env.REACT_APP_BACKEND_URL;

  const settingsData: any = useSelector<any>((state) => state?.settings);

  var dateObj = new Date();
  var year = dateObj.getUTCFullYear();

  // useEffect(() => {
  //   if (Object.keys(settings).length === 0 && settingsData == undefined) {
  //     axios({
  //       method: "get",
  //       url: `${base_url}/api/settings`,
  //       headers: {
  //         "Accept": "application/json",
  //         'Access-Control-Allow-Methods': 'GET, POST',
  //       },
  //     }).then((response) => {
  //       if (response.status != 401) {
  //         setSettings(response.data.data);
  //         dispatch(setSettingsAll(response.data.data))
  //         let URL = window.location.href.split("/");
  //           if (!URL.includes("shop")) {
  //             const faviconLink = document.getElementById(
  //               "favicon"
  //             ) as HTMLLinkElement;
  //             if (faviconLink) {
  //               faviconLink.href = response.data.data.WebsiteSettings.logo_path +
  //               response.data.data.WebsiteSettings.style_fav
  //             } else {
  //               console.error("Favicon link element not found");
  //             }
  //           }
  //       }
  //     }).catch(function (error) {

  //     })
  //   }
  // }, [])

  useEffect(() => {
    let URL = window.location.href.split("/");
    if (!URL.includes("shop")) {
      const faviconLink = document.getElementById("favicon") as HTMLLinkElement;
      if (faviconLink) {
        faviconLink.href =
          settingsData.WebsiteSettings.logo_path +
          settingsData.WebsiteSettings.style_fav;
      } else {
        console.error("Favicon link element not found");
      }
    }
  }, []);

  return (
    <div>
      {jsonData && (
        <style type="text/css">
          {`
            :root {
              --footer-background: #${jsonData?.theme_2?.home?.footer?.bg_color};
              --footer-header: #${jsonData?.theme_2?.home?.footer?.section_heading_color};
              --footer-paragraph: #${jsonData?.theme_2?.home?.footer?.section_paragraph_color};
          }
          .footer.footer-split-layout {
            background: var(--footer-background);
            padding: 60px 0 0;
            color: #fff;
          }
          .footer.footer-split-layout .footer-split-brand {
            padding-right: 30px;
            border-right: 1px solid rgba(255,255,255,0.08);
          }
          .footer.footer-split-layout .footer-split-brand .footer-logo {
            margin-bottom: 20px;
          }
          .footer.footer-split-layout .footer-split-brand .footer-logo img {
            max-width: 180px;
            height: auto;
            display: block;
          }
          .footer.footer-split-layout .footer-split-brand .footer-about-text {
            color: var(--footer-paragraph);
            line-height: 1.7;
            margin-bottom: 22px;
          }
          .footer-floating-whatsapp {
            position: fixed;
            right: 24px;
            bottom: 24px;
            z-index: 9999;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 12px 20px;
            background: #25D366;
            border-radius: 50px;
            color: #fff;
            font-size: 15px;
            font-weight: 600;
            text-decoration: none;
            box-shadow: 0 6px 18px rgba(37, 211, 102, 0.45);
            transition: 0.3s;
          }
          .footer-floating-whatsapp:hover {
            background: #1ebe5b;
            color: #fff;
            transform: translateY(-2px);
            box-shadow: 0 10px 24px rgba(37, 211, 102, 0.55);
          }
          .footer-floating-whatsapp i {
            font-size: 20px;
          }
          .footer.footer-split-layout .footer-contact-social {
            margin-top: 18px;
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            padding: 0;
            list-style: none;
          }
          .footer.footer-split-layout .footer-contact-social .foo-icon {
            width: 36px;
            height: 36px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: rgba(255,255,255,0.08);
            color: #fff;
            transition: 0.3s;
          }
          .footer.footer-split-layout .footer-contact-social .foo-icon:hover {
            background: var(--footer-header);
            color: var(--footer-background);
          }
          .footer.footer-split-layout .footer-split-brand .footer-app-buttons {
            display: flex;
            gap: 12px;
          }
          .footer.footer-split-layout .footer-split-brand .footer-app-buttons img {
            max-width: 130px;
          }
          .footer.footer-split-layout .footer-split-links h4 {
            color: var(--footer-header);
            font-size: 16px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 18px;
            position: relative;
            padding-bottom: 10px;
          }
          .footer.footer-split-layout .footer-split-links h4::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 32px;
            height: 2px;
            background: var(--footer-header);
          }
          .footer.footer-split-layout .footer-split-links ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          .footer.footer-split-layout .footer-split-links ul li {
            margin-bottom: 10px;
            text-align: left;
          }
          .footer.footer-split-layout .footer-split-links ul li a,
          .footer.footer-split-layout .footer-split-links ul li span {
            color: var(--footer-paragraph);
            text-decoration: none;
            font-size: 14px;
            transition: 0.3s;
            display: inline-flex;
            align-items: flex-start;
            gap: 6px;
          }
          .footer.footer-split-layout .footer-split-links ul li a:hover {
            color: var(--footer-header);
            padding-left: 4px;
          }
          .footer.footer-split-layout .footer-bottom-bar {
            margin-top: 40px;
            padding: 18px 0;
            border-top: 1px solid rgba(255,255,255,0.08);
            text-align: center;
          }
          .footer.footer-split-layout .footer-bottom-bar .footer-last {
            margin: 0;
            color: var(--footer-paragraph);
            font-size: 14px;
          }
          @media (max-width: 991px) {
            .footer.footer-split-layout .footer-split-brand {
              padding-right: 15px;
              border-right: none;
              border-bottom: 1px solid rgba(255,255,255,0.08);
              padding-bottom: 30px;
              margin-bottom: 30px;
            }
          }
          `}
        </style>
      )}
      <footer className="footer footer-split-layout">
        <div className="container">
          <div className="row footer-split-top">
            <div className="col-lg-5 col-md-12 footer-split-brand">
              {settingsData?.WebsiteSettings?.logo_path &&
                settingsData?.WebsiteSettings?.style_logo_en && (
                  <div className="footer-logo">
                    <img
                      src={
                        settingsData.WebsiteSettings.logo_path +
                        settingsData.WebsiteSettings.style_logo_en
                      }
                      alt={settingsData?.WebsiteSettings?.site_title_en || "logo"}
                    />
                  </div>
                )}
              {jsonData?.theme_2?.home?.footer?.footer_section?.about_section
                ?.text && (
                <p className="footer-about-text">
                  {
                    jsonData?.theme_2?.home?.footer?.footer_section
                      ?.about_section?.text
                  }
                </p>
              )}
              <div className="footer-app-buttons">
                <a
                  target="_blank"
                  href={
                    jsonData?.theme_2?.home?.footer?.footer_section
                      ?.mobile_link_section?.ios_link || "javascript:void(0)"
                  }
                >
                  <img src={appstore} alt="App Store" />
                </a>
                <a
                  target="_blank"
                  href={
                    jsonData?.theme_2?.home?.footer?.footer_section
                      ?.mobile_link_section?.android_link ||
                    "javascript:void(0)"
                  }
                >
                  <img src={googleplay} alt="Google Play" />
                </a>
              </div>
            </div>
            <div className="col-lg-7 col-md-12">
              <div className="row footer-split-links">
                <div className="col-md-4 col-sm-6">
                  <h4>Quick Links</h4>
                  <ul>
                    <li>
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/pricelist");
                        }}
                      >
                        Price List
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/aboutUs");
                        }}
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/termsAndConditions");
                        }}
                      >
                        Terms &amp; Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/privacyPolicy");
                        }}
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/cookiePolicy");
                        }}
                      >
                        Cookie Policy
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 col-sm-6">
                  <h4>Explore</h4>
                  <ul>
                    <li>
                      <a target="_blank" href={blogUrl}>
                        Blogs
                      </a>
                    </li>
                    <li>
                      <a href="/#services-section">How It Works</a>
                    </li>
                    <li>
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/areaCovered");
                        }}
                      >
                        Locations
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/Contactus");
                        }}
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 col-sm-12">
                  <h4>Contact</h4>
                  <ul>
                    {jsonData?.theme_2?.home?.footer?.mbl_number && (
                      <li>
                        <a
                          href={`tel:${jsonData?.theme_2?.home?.footer?.mbl_number}`}
                        >
                          <i className="uil uil-phone-volume me-2"></i>
                          {jsonData?.theme_2?.home?.footer?.mbl_number}
                        </a>
                      </li>
                    )}
                    {jsonData?.theme_2?.home?.footer?.email_val && (
                      <li>
                        <a
                          href={`mailto:${jsonData?.theme_2?.home?.footer?.email_val}`}
                        >
                          <i className="uil uil-envelopes me-2"></i>
                          {jsonData?.theme_2?.home?.footer?.email_val}
                        </a>
                      </li>
                    )}
                    {jsonData?.theme_2?.home?.footer?.address_val && (
                      <li>
                        <span>
                          <i className="uil uil-map-marker me-2"></i>
                          {jsonData?.theme_2?.home?.footer?.address_val}
                        </span>
                      </li>
                    )}
                  </ul>
                  <ul className="footer-contact-social">
                    {jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                      ?.facebook?.is_enable && (
                      <li>
                        <a
                          href={`https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.facebook?.facebook_link}`}
                          target="_blank"
                          className="foo-icon"
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                    )}
                    {jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                      ?.instagram?.is_enable && (
                      <li>
                        <a
                          href={`https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.instagram?.instagram_link}`}
                          target="_blank"
                          className="foo-icon"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    )}
                    {jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                      ?.twitter?.is_enable && (
                      <li>
                        <a
                          href={`https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.twitter?.twitter_link}`}
                          target="_blank"
                          className="foo-icon"
                        >
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                    )}
                    {jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                      ?.linkedin?.is_enable && (
                      <li>
                        <a
                          href={`https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.linkedin?.linkedin_link}`}
                          target="_blank"
                          className="foo-icon"
                        >
                          <i className="fab fa-linkedin"></i>
                        </a>
                      </li>
                    )}
                    {jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                      ?.youtube?.is_enable && (
                      <li>
                        <a
                          href={`https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.youtube?.youtube_link}`}
                          target="_blank"
                          className="foo-icon"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom-bar">
            <p className="footer-last">
              {year} ©{" "}
              {Object.keys(settings).length > 0
                ? settings?.WebsiteSettings?.site_title_en
                : settingsData?.WebsiteSettings?.site_title_en}
              . All rights reserved. | Powered by&nbsp;
              <a href="http://www.bestatservices.com" target="blank">
                www.bestatservices.com
              </a>
            </p>
          </div>
        </div>
      </footer>
      {jsonData?.theme_2?.home?.footer?.footer_section?.social_media
        ?.whatsapp?.is_enable &&
        jsonData?.theme_2?.home?.footer?.footer_section?.social_media
          ?.whatsapp?.whatsapp_link && (
          <a
            className="footer-floating-whatsapp"
            href={
              jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                ?.whatsapp?.whatsapp_link
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp"></i>
            Book on WhatsApp
          </a>
        )}
    </div>
  );
}

export default FooterTwo;
